import { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { isVideoLive } from 'screens/Live/LiveHelpers';
import { isUpcomingContent } from 'helpers/ContentHelper';

const useSearchResults = ({ panels, searchInput, setPanelCount }) => {
  const getPanels = useCallback(() => {
    const currentLivePanels = [];
    const currentUpcomingPanels = [];
    if (!_.isEmpty(panels)) {
      for (let i = 0; i < panels?.member?.length; i += 1) {
        for (let x = 0; x < panels?.member[i]?.items?.member?.length; x += 1) {
          const panelItem = panels?.member[i]?.items?.member[x];
          if (panelItem && searchInput) {
            if (
              panelItem?.headline?.toLowerCase().includes(searchInput.toLowerCase()) ||
              panelItem?.seriesName?.toLowerCase().includes(searchInput.toLowerCase())
            ) {
              if (isVideoLive(panelItem)) {
                currentLivePanels.push(panelItem);
              }
              if (!isVideoLive(panelItem) && isUpcomingContent(panelItem)) {
                currentUpcomingPanels.push(panelItem);
              }
            }
          }
        }
      }
    }

    return {
      livePanels: _.uniqBy(currentLivePanels, e => e['@id']),
      upcomingPanels: _.uniqBy(currentUpcomingPanels, e => e['@id']),
    };
  }, [panels, searchInput]);
  const [searchPanels, setPanels] = useState(() => getPanels());
  const { livePanels, upcomingPanels } = searchPanels;

  useEffect(() => {
    setPanels(getPanels);
  }, [getPanels, panels, searchInput]);

  useEffect(() => {
    const { livePanels, upcomingPanels } = searchPanels;
    setPanelCount(livePanels.length + upcomingPanels.length);
  }, [searchPanels, setPanelCount]);

  useEffect(() => () => setPanelCount(0), [setPanelCount]);

  const sortedLivePanels = livePanels?.sort((a, b) => {
    const formatA = new Date(a.startDate);
    const formatB = new Date(b.startDate);
    return formatA - formatB;
  });

  const sortedUpcomingPanels = upcomingPanels?.sort((a, b) => {
    const formatA = new Date(a.startDate);
    const formatB = new Date(b.startDate);
    return formatA - formatB;
  });
  console.log({ upcomingPanels });
  const shouldRender =
    panels &&
    searchInput?.length > 1 &&
    (sortedLivePanels.length > 0 || sortedUpcomingPanels.length > 0);
  return { sortedLivePanels, sortedUpcomingPanels, shouldRender };
};

export default useSearchResults;
